import React from "react";
import styled from "styled-components";

import SelectProfileAttribute from "components/Common/SelectProfileAttribute";

const FeedbackTableSettings = props => {
  const {
    className,
    userNameProp,
    emailProp,
    updateAccountMetaAndFlushMeta
  } = props;

  return (
    <div className={className}>
      {props.children}
      <div className="table-column-setting user-name-selection">
        <SelectProfileAttribute
          value={userNameProp}
          onChange={field =>
            updateAccountMetaAndFlushMeta({ userNameField: field.value })
          }
          placeholder="Select name field"
        />
      </div>

      <div className="table-column-setting user-email-selection">
        <SelectProfileAttribute
          value={emailProp}
          onChange={field =>
            updateAccountMetaAndFlushMeta({ userEmailField: field.value })
          }
          placeholder="Select email field"
        />
      </div>
    </div>
  );
};

export default styled(FeedbackTableSettings)`
  display: flex;
  align-items: center;

  .table-column-setting {
    margin: 0 10px;

    &.user-name-selection {
      .select-profile-attribute {
        width: 160px;
        min-width: 160px;
      }
    }

    &.user-email-selection {
      .select-profile-attribute {
        width: 180px;
        min-width: 180px;
      }
    }
  }
`;
